<!-- Table Card -->
<div class="p-3">
  <!-- Title -->
  <h5 class="text-center text-md-start fw-bold flex-grow-1 mb-3">
    Worksheet Entry Details
  </h5>
  <div class="row mb-3">
    <div class="col-12">
      <div class="d-flex flex-column flex-md-row flex-wrap justify-content-between align-items-center gap-3">


        <!-- Total Added Completed Images -->
        <!-- <div class="form-floating text-sm">
        <input type="text"
               class="form-control"
               [value]="anyAddedImageCount"
               id="anyAddedImageCount"
               readonly />
        <label for="anyAddedImageCount">Any Added Image</label>
      </div> -->

        <!-- Total Completed Images -->
        <div class="form-floating text-sm">
          <input type="text" class="form-control" [value]="TotalCompletedCount" id="completedImagesInput" readonly />
          <label for="completedImagesInput">Total Completed Images</label>
        </div>

        <!-- Total Index Count -->
        <div class="form-floating text-sm">
          <input type="text" class="form-control" [value]="TotalIndexCount" id="totalIndexCount" readonly />
          <label for="totalIndexCount">Total Index/Image Count</label>
        </div>

        <!-- Total No Extractable Data -->
        <div class="form-floating text-sm">
          <input type="text" class="form-control" [value]="noExtractableDataCount" id="noExtractableDataCount"
            readonly />
          <label for="noExtractableDataCount">No Extractable & Administrative Images</label>
        </div>

        <!-- Total Accountable Indexing Count -->
        <div class="form-floating text-sm">
          <input type="text" class="form-control" [value]="accountableIndexingCount" id="accountableIndexingCount"
            readonly />
          <label for="accountableIndexingCount">Accountable Indexing/Image Count</label>
        </div>

        <!-- Total Accountable Indexing Count -->
        <!-- <div class="form-floating text-sm">
          <input type="text" class="form-control" [value]="accountIndexingCost | currency : 'INR'"
            id="accountIndexingCost" readonly />
          <label for="accountIndexingCost">Accountable Cost</label>
        </div> -->


        <!-- Wags Month Dropdown -->
        <div class="form-floating text-sm">
          <select class="form-select" [(ngModel)]="wagsMonth" (change)="wagsMonthBasedDetailsGet(wagsMonth)"
            id="wagsMonthSelect">
            <option selected disabled value="">Select a Wags Month</option>
            <option *ngFor="let month of getAllWagsMonth">{{ month }}</option>
          </select>
          <label for="wagsMonthSelect">List Of Wags Month</label>
        </div>


        <div class="form-floating text-sm">
          <select class="form-select" [(ngModel)]="selectedDate" (change)="onDateChange()"> 
            <option value="">All Dates</option>
            <option *ngFor="let d of uniqueDates" [value]="d">
              {{ d | date:'dd-MM-yyyy' }}
            </option>
          </select>
          <label for="wagsMonthSelect">Date Filter</label>
        </div>

      </div>
    </div>
  </div>


  <div class="table-responsive mt-4 table-wrapper-scroll-y tableFixHead">
    <table class="table table-bordered table-rounded text-center">
      <thead class="table-primary text-sm">
        <tr>
          <!-- Rounded corners on top left and right headers -->
          <th class="rounded-start">S.No</th>
          <th>Date</th>
          <th>Batch Number</th>
          <th>Page Starting No</th>
          <th>Page Ending No</th>
          <th>Total Given Images</th>
          <th>Added Images</th>
          <th>Completed Images</th>
          <th>Pending Images</th>
          <th>Total Indexing/Images</th>
          <th>No Extractable & Administrative Images</th>
          <th>Accountable Indexing/Images</th>
          <th>Leave Status</th>
          <th>Reassigned Status</th>
          <th>Reassigned Count</th>
          <th class="rounded-end">Remove</th>
        </tr>
      </thead>
      <tbody *ngIf="filteredEntries.length > 0; else noDataFound">
        <tr *ngFor="let entry of filteredEntries; let i = index"
          [class.last-row]="i === filteredEntries.length - 1">
          <td>{{ i + 1 }}</td>
          <td>{{ (entry?.entryDate | date : 'dd-MM-yyyy') || '-' }}</td>
          <td>{{ entry?.batchNumber || '-' }}</td>
          <td>{{ entry?.pageStartingNumber || '-' }}</td>
          <td>{{ entry?.pageEndingNumber || '-' }}</td>
          <td>{{ entry?.totalImageCount || '-' }}</td>
          <td>{{ entry?.anyAddedImageCount || '-' }}</td>
          <td>{{ entry?.noOfImagesCompleted || '-' }}</td>
          <td>{{ entry?.availableCount || '-' }}</td>
          <td>{{ entry?.noOfLinesTyped || '-' }}</td>
          <td>{{ entry?.noExtractableData || '-' }}</td>
          <td>{{ entry?.accountableIndexing || '-' }}</td>
          <td>{{ entry?.isLeave === true ? 'Yes' : entry?.isLeave === false ? 'No' : '-' }}</td>
          <td>{{ entry?.isAssigned === true ? 'Yes' : entry?.isAssigned === false ? 'No' : '-' }}</td>
          <td>{{entry?.assignCount || "-" }}</td>
          <td>
            <span *ngIf="!checkLastEntryData(entry)">-</span>
            <span *ngIf="checkLastEntryData(entry)">
              <i class="fa fa-trash text-danger" type="button" (click)="removeEntryDetails(entry?.employeeDailyWorkLogId)"></i>
            </span>
          </td>
        </tr>
      </tbody>
      <ng-template #noDataFound>
        <tr>
          <td colspan="16" class="text-center text-danger fw-bolder">Data Not Found</td>
        </tr>
      </ng-template>
    </table>
  </div>

</div>